export default "__VITE_ASSET__By18TN50__"